<template>
    <div class="card oc-generic-card-body">
      <span style="display: none">{{loanApplication}}</span>
      <div class="row mt-2">
        <div class="col">
          <div class="col-sm-6 col-md-9 col-lg-10 col-xl-8 col-xxl-6" >
            <el-button
              type="primary"
              style="font-size: 12.5px"
              plain
              size="medium"
              class="oc-action-btn"
              @click="redirectBack"><i class="fa fa-backward mr-3" style="float: left"></i> Back
            </el-button>
<!--            <button type="button" class="btn oc-backBtn oci-show-back"  @click="redirectBack" style="background: #7bbf00;">
              <i class="fa fa-backward"></i> Back
            </button>
            <button type="button" class="btn oc-backBtn oci-hide-back"  @click="redirectBack" style="background: #7bbf00;">
              <i class="fa fa-backward"></i>
            </button>-->
          </div>
        </div>

        <div class="col-md-9 col-sm-9 oci-show-menu">
          <div class="row">
            <div v-if="path && path.includes('/lender/') && false" class="col-sm-6 col-md-4 col-lg-4 col-xxl mb-1">
              <el-button style="font-size: 12.5px" icon="" class="el-button--primary oc-action-btn"
                plain size="medium" @click="redirectToScenarioBuilder">
                <i class="fa fa-table" style="float: left"></i> Qualify
              </el-button>
<!--              <button type="button" class="btn btn-success oc-action-btn"  @click="redirectToScenarioBuilder">
                Qualify&nbsp;&nbsp;<i class="fa fa-table"></i>
              </button>-->
            </div>
            <div class="col-sm-6 col-md-4 col-lg-4 col-xxl mb-1">
              <el-button id="uad-mortgage-btn" style="font-size: 12.5px;" :style="$route.path.includes('/lender/') ? 'max-width: 220px':''" icon="" class="el-button--primary oc-action-btn"
                plain size="medium" @click="redirectToMortgageApp">
                <i class="fa fa-table" style="float: left; "></i> Mortgage App
              </el-button>
<!--              <button type="button" class="btn btn-success oc-action-btn"  @click="redirectToMortgageApp">
                Mortgage App&nbsp;&nbsp;<i class="fa fa-table"></i>
              </button>-->
            </div>
            <div v-if="!$route.path.includes('/lender/conditions') && !$route.path.includes('/broker/conditions') && !$route.path.includes('/lender/')" class="col-sm-6 col-md-4 col-lg-4 col-xxl mb-1">
              <el-button style="font-size: 12.5px" class="el-button--primary oc-action-btn"
                         plain size="medium" @click="redirectToConditions">
                <i class="el-icon-success" style="float: left"></i>
                Conditions
              </el-button>
<!--              <button type="button" class="btn btn-success oc-action-btn" @click="redirectToConditions">
                Conditions&nbsp;&nbsp;<i class="fa fa-check-square"></i>
              </button>-->
            </div>
            <div v-if="!$route.path.includes('/lender/otherDocuments') && !$route.path.includes('/broker/otherDocuments') && !$route.path.includes('/lender/')" class="col-sm-6 col-md-4 col-lg-4 col-xxl mb-1">
              <el-button style="font-size: 12.5px" class="el-button--primary oc-action-btn"
                         plain size="medium" @click="redirectToOtherDocuments">
                <i class="el-icon-document" style="float: left"></i>
                Documents
              </el-button>
<!--              <button type="button" class="btn btn-success oc-action-btn" @click="redirectToOtherDocuments">
                Other Docs&nbsp;&nbsp;<i class="fa fa-file"></i>
              </button>-->
            </div>
            <div v-if="path && !path.includes('/lender/') && !$route.path.includes('/broker/documents') && !$route.path.includes('/lender/')" class="col-sm-6 col-md-4 col-lg-4 col-xxl mb-1">
              <el-button style="font-size: 12.5px" icon="" class="el-button--primary oc-action-btn"
                         plain size="medium" @click="redirectToForms">
                <i class="fa fa-list-ul" style="float: left"></i> Forms
              </el-button>
<!--              <button type="button" class="btn btn-success oc-action-btn" @click="redirectToForms">
                Forms&nbsp;&nbsp;<i class="fa fa-list-ul"></i>
              </button>-->
            </div>
            <div v-if="path && !path.includes('/lender/')" class="col-sm-6 col-md-4 col-lg-4 col-xxl mb-1">
              <el-button style="font-size: 12.5px" icon="" class="el-button--primary oc-action-btn"
                         plain size="medium" @click="redirectToLenderSubmit">
                <i class="fa fa-table" style="float: left"></i> Deal Submit&nbsp;&nbsp;
              </el-button>
<!--              <button type="button" class="btn btn-success oc-action-btn" @click="redirectToLenderSubmit">
              Deal Submit <i class="fa fa-table"></i>
            </button>-->
            </div>
          </div>
        </div>
        <div class="oci-hide-dropdown">
          <!--<ul>
            <li><a href="#" title="Mortgage App" @click="redirectToMortgageApp">Mortgage App</a></li>
          <li><a href="#" title="Conditions" @click="redirectToConditions">Conditions</a></li>
          <li><a href="#" title="Other Documents" @click="redirectToOtherDocuments">Other Documents</a></li>
          <li><a href="#" title="Forms" @click="redirectToForms">Forms</a></li>
          <li><a href="#" title="Deal Submit" @click="redirectToLenderSubmit">Deal Submit</a></li>
        </ul>-->
          <!--<el-dropdown @command="handleCommand" size="medium">
            <el-button size="mini" class="btn-success"><i class="el-icon-plus el-icon&#45;&#45;right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="this.redirectToMortgageApp()">Mortgage App</el-dropdown-item>
              <el-dropdown-item command="this.redirectToConditions()">Conditions</el-dropdown-item>
              <el-dropdown-item command="this.redirectToOtherDocuments()">Other Documents</el-dropdown-item>
              <el-dropdown-item command="this.redirectToForms()">Forms</el-dropdown-item>
              <el-dropdown-item command="this.redirectToLenderSubmit()">Deal Submit</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>-->
          <el-button @click="drawer = true" class="btn-success mr-3">
            Actions
          </el-button>
          <el-drawer
            title=""
            size="35%"
            :show-close="false"
            :visible.sync="drawer"
            :direction="direction">
            <div class="pb-4">
              <ul>
                <li v-if="path && path.includes('/lender/')"><a href="#" title="Mortgage App" @click="redirectToScenarioBuilder"><i class="fa fa-table"></i>&nbsp;&nbsp;&nbsp;  Qualify</a></li>
                <hr class="mt-0 mb-0 pt-1 pb-1">
                <li><a href="#" title="Mortgage App" @click="redirectToMortgageApp"><i class="fa fa-table"></i>&nbsp;&nbsp;&nbsp;  Mortgage App</a></li>
                <hr class="mt-0 mb-0 pt-1 pb-1">
                <li v-if="!$route.path.includes('/lender/conditions')"><a href="#" title="Conditions" @click="redirectToConditions"><i class="fa fa-check-square"></i> &nbsp;&nbsp;&nbsp; Conditions</a></li>
                <hr v-if="!$route.path.includes('/lender/conditions')" class="mt-0 mb-0 pt-1 pb-1">
                <li v-if="!$route.path.includes('/lender/otherDocuments')"><a href="#" title="Other Documents" @click="redirectToOtherDocuments"><i class="fa fa-file"></i>&nbsp;&nbsp;&nbsp;  Other Documents</a></li>
                <hr v-if="path && !path.includes('/lender/') && !$route.path.includes('/lender/otherDocuments')" class="mt-0 mb-0 pt-1 pb-1">
                <li v-if="path && !path.includes('/lender/')"><a href="#" title="Forms" @click="redirectToForms"> <i class="fa fa-list-ul"></i> &nbsp;&nbsp;&nbsp;  Forms</a></li>
                <hr v-if="path && !path.includes('/lender/')" class="mt-0 mb-0 pt-1 pb-1">
                <li v-if="path && !path.includes('/lender/')"><a href="#" title="Deal Submit" @click="redirectToLenderSubmit"><i class="fa fa-table"></i> &nbsp;&nbsp;&nbsp; Deal Submit</a></li>
              </ul>
            </div>

<!--            <span>Hi, there!</span>-->
          </el-drawer>
        </div>
        <!--<div class="oci-hide-menu oci-hide-dropdown"
             style="float: right;margin-right: 15px;color: #7bbf00;font-size: large" @click="clickActionButtons">
          <i class="fa fa-bars"></i>
        </div>-->
      </div>
    </div>
</template>

<script>
  import {Button, Dropdown, DropdownItem, DropdownMenu, Row, Col, Drawer} from 'element-ui';

  export default {
    name: "ActionBar",
    components: {
      [Button.name]: Button,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Row.name]: Row,
      [Col.name]: Col,
      [Drawer.name]: Drawer,
    },
    data(){
      return{
        drawer: false,
        direction: 'btt',
        openActionButtons:false
      }
    },
    props: {
      path: null
    },
    computed:{

      loanApplication: {
        get(){
          let allAppApps = this.$store.getters.allApplicationApplicants;
          if(allAppApps && allAppApps[0]){
            return allAppApps[0].loanApplication
          }
        }
      },
    },
    methods: {
      handleClose(done) {
        this.$confirm('Are you sure you want to close this?')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      handleCommand(command){
        console.log(command);
        eval(command);
      },
      redirectBack() {
        console.log("redirecting", this.path)
        if(this.path === '/lender/lenderClientTable' || this.path === '/broker/brokerpage'){
          this.$router.push({path: this.path});
        }
        else {
          this.$router.push({path: this.path + '?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp});
        }
      },
      redirectToScenarioBuilder(){
        this.$router.push({path: '/lender/lenderResponse?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp})
      },
      redirectToLenderSubmit() {
        this.$router.push({path: '/broker/lenderSubmit?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp})
      },
      redirectToMortgageApp() {
        if(!this.loanApplication.mortgageAppStarted){
          this.$store.dispatch('startMortgageApp', this.$crypto.decodeIdParam(this.$route.query.loanApp));
        }

        if(this.path.includes('/lender/')){
          this.$router.push({path: '/lender/lenderMtgApp?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp})
        } else {
          this.$router.push({path: '/broker/mortgageapp?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp})

        }
      },
      redirectToConditions() {
        if(this.path.includes('/lender/')){
          this.$router.push({path: '/lender/conditions?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp})
        }
        else {
          this.$router.push({path: '/broker/conditions?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp})
        }
      },
      async redirectToForms() {
        // @TODO this needs to be worked on .. we need a form repository design session and build
        // console.warn('TODO > application.documents form repository for loan_application design and build')
        this.$router.push({path: '/broker/documents?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp});
      },
      redirectToOtherDocuments() {
        if(this.path.includes('/lender/')){
          this.$router.push({path: '/lender/otherDocuments?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp});
        }
        else {
          this.$router.push({path: '/broker/otherDocuments?appApplicant=' + this.$route.query.appApplicant + '&loanApp=' + this.$route.query.loanApp});
        }
      },
      clickActionButtons(){
        this.openActionButtons = !this.openActionButtons;
      }
    },
  }
</script>
<style scoped>
/* Desktop Styles */
@media (min-width: 1025px) {
  .oc-backBtn {
    max-height: 38px;
    width: 100%;
    font-size: smaller;
    border-radius: 5px;
    margin: 2px !important;
    background-color: #7bbf00;
  }

  .oc-action-btn {
    height:38px;
    width: 100%;
    font-size: smaller;
    border-radius: 5px;
    margin: 1px !important;
  }
  .oci-hide-back {
    display: none !important;
  }
  .oci-hide-menu {
    display: none !important;
  }
  .oci-hide-dropdown{
    display: none !important;
  }
}

 /*Media Query for high resolution  Tablets, Ipads */
 @media (min-width: 769px) and (max-width: 1024px) {
   .oc-backBtn{
     height: 45px;
     width: 60px;
     font-size: smaller;
     border-radius: 5px;
     margin:2px !important;
     background: #7bbf00;
   }
   .oc-action-btn{
     height: 45px;
     width: 100%;
     font-size: smaller;
     border-radius: 5px;
     margin:2px !important;
     display: block;
   }
   .oci-show-back{
     display: none !important;
   }
   .oci-hide-dropdown{
     display: none !important;
   }
 }

  /* Tablet Styles */
  @media (min-width: 577px) and (max-width: 768px) {
    .oc-backBtn{
      height: 45px;
      width: 60px;
      font-size: smaller;
      border-radius: 5px;
      margin:2px !important;
      background: #7bbf00;
    }
    .oc-action-btn{
      height: 45px;
      width: 100%;
      font-size: smaller;
      border-radius: 5px;
      margin:2px !important;
      display: block;
    }
    .oci-show-back{
      display: none !important;
    }
    .oci-hide-dropdown{
      display: none !important;
    }
  }


  /* Mobile Styles */
  @media (max-width: 576px) {
    .oc-backBtn{
      height: 30px;
      width: 50px;
      font-size: x-small;
      border-radius: 5px;
      margin:2px !important;
      padding: 2px;
      background: #7bbf00;
    }
    /*.oc-backBtn:hover {*/
    /*  background-color: #47a447;*/
    /*}*/
    .oc-action-btn{
      height: 40px;
      width: 100px;
      font-size: x-small;
      border-radius: 5px;
      margin:2px !important;
    }
    .oci-show-back{
      display: none !important;
    }
    .oci-show-menu{
      display: none !important;
    }

  }
</style>
